// extracted by mini-css-extract-plugin
export default {"formError":"FormError_formError__hbJN3"};